import React, { Component } from "react";
import Images from "../Images";
import SlotsCourasel from "./SlotsCourasel";


export class NewGames extends Component {
 convertToArrays =(inputArray, chunkSize) =>{
    const result = [];
    let addSlideIndicator=0;
    
    for (let i = 0; i < inputArray.length; i += chunkSize) {
      result.push(inputArray.slice(i, i + chunkSize));
    }
    while (result[result.length -1] && result.length > 1 && result[result.length -1].length !== chunkSize && addSlideIndicator <= chunkSize){
      if(inputArray[addSlideIndicator]){
        result[result.length -1].push(inputArray[addSlideIndicator])
      }
      addSlideIndicator++;
    }    
    return result;
  }
  render() {
    const {slides , history , newImagesType , row5Col2Categories} = this.props
    let slidesGroups;
    if(slides && slides.length> 0){
      slidesGroups=this.convertToArrays(slides , 3)
    }
    return (
      <div className="new-games-wrapper">
        {" "}
        <SlotsCourasel
          title={row5Col2Categories && row5Col2Categories[0].categoryName}
          autoPlay={false}
          slides={slidesGroups}
          type={"images"}
          history={history}
          multipleSlides={true}
          imageType={newImagesType}
        />
      </div>
    );
  }
}

export default NewGames;
